module.exports = __webpack_public_path__ + "img/8.d7733c1c.png";